import React, { useState } from "react";
import { Container, Button, ProgressBar } from "react-bootstrap";
import {
  IconPlayerPlay,
  IconClock,
  IconTrendingUp,
} from "@tabler/icons-react";

const HeroVideo = ({ video, onPlay }) => {
  const [heroImageError, setHeroImageError] = useState(false);

  if (!video) return null;

  const heroImageSrc = heroImageError
    ? "/placeholder-hero.jpg"
    : video.thumbnail_final_url ||
      video.thumbnail_url ||
      "/placeholder-hero.jpg";

  return (
    <div className="crs-hero">
      <div className="crs-hero__bg">
        <img
          src={heroImageSrc}
          alt={video.title}
          onError={() => setHeroImageError(true)}
        />
        <div className="crs-hero__gradient" />
      </div>
      <Container>
        <div className="crs-hero__content">
          <div className="crs-hero__badge">
            <IconTrendingUp size={12} />
            Em destaque
          </div>
          <h1 className="crs-hero__title">{video.title}</h1>
          <p className="crs-hero__desc">
            {video.description ||
              `Continue de onde parou em ${video.category_name}`}
          </p>
          <div className="crs-hero__meta">
            <span className="crs-hero__category">{video.category_name}</span>
            <span className="crs-hero__duration">
              <IconClock size={12} className="me-1" />
              {video.duration_display}
            </span>
          </div>
          <Button
            className="crs-hero__cta"
            onClick={() => onPlay(video)}
          >
            <IconPlayerPlay size={18} />
            {video.progress_percent > 0 ? "Continuar" : "Assistir"}
          </Button>
          {video.progress_percent > 0 && (
            <ProgressBar
              now={video.progress_percent}
              className="crs-hero__progress"
            />
          )}
        </div>
      </Container>
    </div>
  );
};

export default React.memo(HeroVideo);
